import React, { useState } from 'react';
import api from '../services/api';

function AdminUpload() {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const onFileChange = (e) => {
    setFile(e.target.files[0]);
    setMessage('');
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      setError('Vui lòng chọn file');
      return;
    }

    setLoading(true);
    setError('');
    setMessage('');
    
    const formData = new FormData();
    formData.append('file', file);

    try {
      const res = await api.post('/than-nhan/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      setMessage(res.data.message || 'Upload thành công!');
      if (res.data.errors && res.data.errors.length > 0) {
        setError(`Đã xảy ra lỗi ở một số dòng: ${res.data.errors.join(', ')}`);
      }
      setFile(null);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || 'Lỗi: Không thể upload file');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: 'auto' }}>
      <h2>Upload Danh sách Thân nhân (Excel)</h2>
      
      {/* (CẬP NHẬT) Sửa lại nội dung hướng dẫn */}
      <div style={{ background: '#f4f4f4', padding: '15px', borderRadius: '5px' }}>
        <p><strong>Lưu ý:</strong> File Excel phải có 5 cột với tên chính xác:</p>
        <ul style={{ fontWeight: 'bold' }}>
          <li>ho_ten (Họ tên)</li>
          <li>ngay_sinh (Định dạng YYYY-MM-DD hoặc MM/DD/YY)</li>
          <li>cccd (Số CCCD, hệ thống sẽ tự lấy 3 số cuối)</li>
          <li>dia_chi (Địa chỉ)</li>
          <li>ten_xa (Tên xã, phải khớp 100% với tên xã đã tạo trong CSDL)</li>
        </ul>
      </div>

      <form onSubmit={handleSubmit} style={{ marginTop: '20px' }}>
        <input type="file" onChange={onFileChange} accept=".xlsx, .xls" />
        <button type="submit" disabled={loading || !file}>
          {loading ? 'Đang tải lên...' : 'Upload'}
        </button>
      </form>

      {loading && <p>Đang xử lý file, vui lòng chờ...</p>}
      {message && <p style={{ color: 'green', fontWeight: 'bold' }}>{message}</p>}
      {error && <p style={{ color: 'red', fontWeight: 'bold' }}>{error}</p>}
    </div>
  );
}

export default AdminUpload;

